import { render, staticRenderFns } from "./StatementUpload.vue?vue&type=template&id=19f2699e&scoped=true"
import script from "./StatementUpload.vue?vue&type=script&lang=js"
export * from "./StatementUpload.vue?vue&type=script&lang=js"
import style0 from "./StatementUpload.vue?vue&type=style&index=0&id=19f2699e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f2699e",
  null
  
)

export default component.exports